import axios from 'axios'

// API Base URL - Development modunda Vite proxy kullanılır
// Production'da gerçek backend URL'i kullanılır
const API_BASE_URL = import.meta.env.VITE_API_URL || '/api/v1'

// Toast store referansını tutacak değişken
let toastStore = null

// Demo state - tüm API çağrılarına session parametresi eklemek için
let demoState = {
  isDemo: false,
  sessionId: null
}

// Demo state'i ayarla (LiveAnalysisView'dan çağrılacak)
export const setDemoState = (isDemo, sessionId) => {
  demoState = { isDemo, sessionId }
  console.log('[API] Demo state updated:', demoState)
}

// Demo state'i al
export const getDemoState = () => demoState

// Toast store'u ayarla (main.js'den çağrılacak)
export const setToastStore = (store) => {
  toastStore = store
}

// Axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Request interceptor
api.interceptors.request.use(
  (config) => {
    console.log(`[API] ${config.method?.toUpperCase()} ${config.url}`)
    
    // Token varsa header'a ekle
    const token = sessionStorage.getItem('report_session_token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    
    // Plan ID varsa header'a ekle (opsiyonel)
    const planId = localStorage.getItem('plan_id')
    if (planId) {
      config.headers['X-Plan-ID'] = planId
    }
    
    // Demo modunda session query parametresi ekle
    if (demoState.isDemo && demoState.sessionId) {
      config.params = config.params || {}
      config.params.session = demoState.sessionId
      console.log(`[API] Demo mode: Adding session param ${demoState.sessionId}`)
    }
    
    return config
  },
  (error) => {
    console.error('[API] Request Error:', error)
    return Promise.reject(error)
  }
)

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    // Backend error format: { success: false, error: "...", message: "..." }
    const errorData = error.response?.data || {}
    const errorMessage = errorData.message || errorData.error || error.message
    
    console.error('[API] Response Error:', errorMessage)
    
    // Toast göster (store mevcutsa)
    if (toastStore) {
      const status = error.response?.status
      if (status === 401) {
        // Token geçersiz - logout yap
        toastStore.error('Yetkilendirme Hatası', errorMessage || 'Token geçersiz veya süresi dolmuş.')
        // sessionStorage'ı temizle
        sessionStorage.removeItem('report_session_token')
        localStorage.removeItem('plan_id')
        localStorage.removeItem('user_id')
        localStorage.removeItem('plan_details')
        // Geçersiz erişim sayfasına yönlendir
        if (window.location.pathname !== '/invalid-access' && window.location.pathname !== '/') {
          window.location.href = '/invalid-access'
        }
      } else if (status === 403) {
        toastStore.error('Erişim Engellendi', errorMessage || 'Bu işlem için yetkiniz yok.')
      } else if (status === 404) {
        toastStore.warning('Bulunamadı', errorMessage || 'İstenen kaynak bulunamadı.')
      } else if (status === 500) {
        toastStore.error('Sunucu Hatası', errorMessage || 'Sunucuda bir hata oluştu.')
      } else if (error.code === 'ECONNABORTED') {
        toastStore.error('Zaman Aşımı', 'İstek zaman aşımına uğradı.')
      } else if (!error.response) {
        toastStore.error('Bağlantı Hatası', 'Sunucuya bağlanılamadı.')
      } else {
        toastStore.error('Hata', errorMessage)
      }
    }
    
    // Backend error formatını koru
    return Promise.reject(errorData.error ? errorData : { message: errorMessage })
  }
)

export default api
